import { type ComponentPropsWithoutRef } from 'react';
import { type PlanType } from '@/types';
import { cn } from '@/utils/tailwind.util';
import { AVATAR_BG_COLOR, type AvatarShape, type AvatarSize, DEFAULT_AVATAR_IMAGE, PLAN_GRADIENT_CLASS, SHAPE_MAP, SIZE_MAP } from '../constants/avatar.constants';
import { AvatarFrame } from './AvatarFrame';
const FallbackImage = () => <img src={DEFAULT_AVATAR_IMAGE} alt="" className="size-full object-cover" data-sentry-component="FallbackImage" data-sentry-source-file="FallbackAvatar.tsx" />;
export const FallbackAvatar = ({
  size = 'xs',
  shape = 'circle',
  planType,
  backgroundColor,
  className,
  style,
  ...props
}: ComponentPropsWithoutRef<'div'> & {
  size?: AvatarSize;
  shape?: AvatarShape;
  planType?: PlanType;
  backgroundColor?: string;
}) => {
  const gradientClass = PLAN_GRADIENT_CLASS[planType ?? 'FREE'];
  if (!gradientClass) {
    return <AvatarFrame shape={shape} backgroundColor={backgroundColor} className={cn(SIZE_MAP[size], className)} style={style} {...props}>
        <FallbackImage />
      </AvatarFrame>;
  }

  // 플랜 그라데이션 링은 프레임 바깥을 감싸는 별개 레이어다. 링이 곧 테두리 역할을
  // 하므로 안쪽은 AvatarFrame(=보더 있는 프레임)이 아니라 클리핑 컨테이너만 둔다.
  return <div className={cn('relative inline-flex aspect-square shrink-0 p-[2px]', SHAPE_MAP[shape], gradientClass, SIZE_MAP[size], className)} style={style} {...props} data-sentry-component="FallbackAvatar" data-sentry-source-file="FallbackAvatar.tsx">
      <div className={cn('flex aspect-square size-full items-center justify-center overflow-hidden', SHAPE_MAP[shape])} style={{
      backgroundColor: backgroundColor ?? AVATAR_BG_COLOR
    }}>
        <FallbackImage data-sentry-element="FallbackImage" data-sentry-source-file="FallbackAvatar.tsx" />
      </div>
    </div>;
};